import script from "./RoleSectionContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleSectionContent.vue?vue&type=script&setup=true&lang=ts"

import "./RoleSectionContent.vue?vue&type=style&index=0&id=89624f40&lang=css"

const __exports__ = script;

export default __exports__